/**
 * WEB-916 п.2 — звёзды рейтинга красились жёлтым #faad14, а на белом это
 * 1.9:1. Звезда — нетекстовый элемент интерфейса, порог WCAG 1.4.11 = 3.0:1.
 *
 * Токен, а не литерал: тёмная тема переопределяет его обратно в яркий жёлтый
 * (на #1f1f1f он даёт 8.7:1), а гвард contrast-теста запрещает голые хексы в
 * рендерерах.
 */

/** Порог WCAG 1.4.11 для нетекстовых элементов интерфейса. */
export const RATING_STAR_MIN_CONTRAST = 3;

/** Значение токена в светлой теме (см. styles/global.css). */
export const RATING_STAR_DEFAULT = '#ad6800';

/** Цвет закрашенной звезды — читать только отсюда. */
export const RATING_STAR_COLOR = `var(--color-rating-star, ${RATING_STAR_DEFAULT})`;

/**
 * WEB-1692 юнит 4 — прозрачность НЕЗАКРАШЕННОЙ звезды в блоке «Звёзды оценки».
 *
 * Число вынесено из разметки, потому что теперь у него ДВА читателя: прежняя
 * строка стиля и приглушение варианта А (решение владельца 02.09 — разница
 * состояний считается сама от одного авторского цвета). Две копии разъехались
 * бы при первой правке, и при заданном цвете вид звёзд поехал бы на ровном
 * месте.
 */
export const RATING_STAR_EMPTY_OPACITY = 0.5;
